import { Box, Button, TextField, Typography } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { TextFieldStyles } from "../../../styles/commonStyles";
import { useCallback, useState } from "react";
import { toolsValidationSchema } from "../../../validation/schemas/toolsSchema";

const ToolRequestForm = ({ theme, isMobile, onSuccessChange }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [formData, setFormData] = useState({
    brand: "",
    model: "",
    notes: "",
  });

  const handleInputChange = useCallback(
    (field) => (e) => {
      setFormData((prev) => ({
        ...prev,
        [field]: e.target.value,
      }));
    },
    []
  );

  const onSubmit = () => {
    if (onSuccessChange) {
      onSuccessChange(true);
    }
  };
  return (
    <Box
      width="100%"
      height="100%"
      display="flex"
      flexDirection="column"
      alignItems="center"
    >
      <Box
        display="flex"
        flexDirection="column"
        width={isMobile ? "100%" : "500px"}
        component="form"
        onSubmit={handleSubmit(onSubmit)}
        gap={2}
      >
        <Typography fontWeight="bold" fontSize="14px">
          Richiesta di aggiunta strumento
        </Typography>
        <Typography fontSize="12px" color={theme.palette.custom.infoTextColor}>
          Cupidatat excepteur occaecat exercitation exercitation aliqua. Sunt
          ipsum magna eu cupidatat do cupidatat elit pariatur. Velit do ut
          laboris laborum id laboris mollit proident ea nostrud ad. Sint ipsum
          dolor deserunt nostrud adipisicing ipsum Lorem in et.
        </Typography>
        <Controller
          name="brand"
          control={control}
          rules={toolsValidationSchema.brand}
          render={({ field }) => (
            <TextField
              {...field}
              variant="filled"
              fullWidth
              id="filled-textfield"
              label="Marca"
              sx={{
                ...TextFieldStyles,
              }}
              value={formData.brand || ""}
              error={!!errors.brand}
              helperText={errors.brand?.message}
              onChange={(e) => {
                field.onChange(e);
                handleInputChange("brand")(e);
              }}
            />
          )}
        />
        <Controller
          name="model"
          control={control}
          rules={toolsValidationSchema.model}
          render={({ field }) => (
            <TextField
              {...field}
              variant="filled"
              fullWidth
              id="filled-textfield"
              label="Modello"
              sx={{
                ...TextFieldStyles,
              }}
              value={formData.model || ""}
              error={!!errors.model}
              helperText={errors.model?.message}
              onChange={(e) => {
                field.onChange(e);
                handleInputChange("model")(e);
              }}
            />
          )}
        />
        <Controller
          name="notes"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              variant="filled"
              fullWidth
              id="filled-textfield"
              label="Note"
              sx={{
                "& .MuiFilledInput-root": {
                  backgroundColor: "#E9EEF0",
                },
              }}
              value={formData.notes || ""}
              error={!!errors.notes}
              helperText={errors.notes?.message}
              onChange={(e) => {
                field.onChange(e);
                handleInputChange("notes")(e);
              }}
              multiline
              rows={4}
            />
          )}
        />
        <Button
          variant="contained"
          sx={{ textTransform: "none", height: "40px", borderRadius: 0 }}
          type="submit"
        >
          Invia richiesta
        </Button>
      </Box>
    </Box>
  );
};

export default ToolRequestForm;
